var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPencil2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.35 2.25a.599.599 0 0 1 0 1.198h-2.1A1.8 1.8 0 0 0 3.45 5.25v7.5c0 .995.806 1.801 1.802 1.801h7.5a1.8 1.8 0 0 0 1.801-1.802v-2.1a.599.599 0 0 1 1.197 0v2.1a2.997 2.997 0 0 1-2.999 3h-7.5a2.997 2.997 0 0 1-2.998-3v-7.5A3 3 0 0 1 5.25 2.252z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.084 2.794a2.206 2.206 0 0 1 3.114 3.124l-4.646 4.683a2.817 2.817 0 0 1-1.395.768l-2.148.471a.733.733 0 0 1-.873-.873l.473-2.143a2.82 2.82 0 0 1 .774-1.4zm2.261.857a1.008 1.008 0 0 0-1.421-.005L8.222 8.277c-.222.22-.378.499-.445.805l-.316 1.435 1.438-.317c.304-.067.583-.22.803-.441l4.646-4.684a1.008 1.008 0 0 0-.003-1.424",
  clipRule: "evenodd"
}))));
export default SvgIconPencil2;